import { Box, Container, Stack, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Button from "../../components/ui/Button";
import { ROUTES } from "../../constants/routes";

const NotFound = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  const handleGoHome = () => {
    navigate(ROUTES.HOME);
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          textAlign: "center",
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: "6rem", sm: "8rem", md: "10rem" },
            fontWeight: "bold",
            color: theme.palette.primary.main,
            lineHeight: 1,
            mb: 2,
          }}
        >
          404
        </Typography>

        <Typography
          variant="h3"
          component="h1"
          sx={{
            mb: 2,
            fontWeight: 600,
            color: theme.palette.text.primary,
            fontSize: { xs: "1.5rem", sm: "2rem" },
          }}
        >
          Page Not Found
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mb: 4,
            color: theme.palette.text.secondary,
            maxWidth: "400px",
            fontSize: { xs: "0.875rem", sm: "1rem" },
          }}
        >
          The page you are looking for does not exist or has been moved.
        </Typography>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          sx={{ width: "100%", maxWidth: "300px" }}
        >
          <Button
            onClick={handleGoHome}
            variant="contained"
            fullWidth
            sx={{
              py: 1.5,
              fontSize: "1rem",
              fontWeight: 600,
              with: "100%",
            }}
          >
            Go to Home
          </Button>
        </Stack>
      </Box>
    </Container>
  );
};

export default NotFound;
